import React from 'react'
import {
  CircularProgress,
  IconButtonProps,
  IconButton as MuiIconButton,
  Tooltip,
  TooltipProps,
} from '@mui/material'

export interface IIconButtonProps extends IconButtonProps {
  loading?: boolean,
  square?: boolean,
  placement?: TooltipProps['placement']
  children: React.ReactElement
}

const IconButton = ({
  loading = false,
  size,
  title = '',
  placement = 'top',
  disabled,
  children,
  ...props
}: IIconButtonProps) => {
  const iconSize = size === 'small' ? 1 : size === 'large' ? 3 : 2

  const icon = (
    <MuiIconButton
      size={size}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <CircularProgress color="secondary" size={14} />
      ) : (
        children && React.cloneElement(children, { size: iconSize })
      )}
    </MuiIconButton>
  )

  if (title) {
    return (
      <Tooltip title={title} placement={placement}>
        {icon}
      </Tooltip>
    )
  }

  return icon
}

export default IconButton
